

export type CollapsableExpandableTextValue = string;
